export default __webpack_public_path__ + "static/media/m_engineering_card14_1.cbdd9ec9.png";